// Single source of truth for Aspen area pricing.
// Edit rates here — the Area Rates page and the homepage Airport Rates panel both read from this file.

export const AIRPORT_RATES = [
  { from: "Aspen or Snowmass", to: "Aspen Airport", rate: 80 },
  { from: "Aspen or Snowmass", to: "Eagle or Rifle Airport", rate: 400 },
  { from: "Aspen or Snowmass", to: "Grand Junction", rate: 500 },
  { from: "Aspen or Snowmass", to: "Denver", rate: 900 },
];

export const LOCAL_RATES = [
  { from: "Aspen", to: "Buttermilk, Highlands, T-Lazy 7", rate: 70 },
  { from: "Snowmass", to: "Aspen, Highlands, T-Lazy 7", rate: 80 },
  { from: "Snowmass", to: "Buttermilk", rate: 70 },
  { from: "Aspen", to: "Pine Creek Cookhouse, Woody Creek, Basalt", rate: 100 },
  { from: "Snowmass", to: "Pine Creek Cookhouse", rate: 125 },
  { from: "Aspen or Snowmass", to: "Willits, El Jebel", rate: 125 },
  { from: "Aspen or Snowmass", to: "Carbondale", rate: 150 },
  { from: "Aspen or Snowmass", to: "Glenwood Springs", rate: 175 },
  { from: "Aspen or Snowmass", to: "Crested Butte", rate: 600 },
  { from: "Aspen or Snowmass", to: "Vail, Beaver Creek", rate: 500 },
];
